import './DataTableV2Rows.css';
export var dataTableV2BodyCSS = '_q3b8hif-2-0-1';
export var dataTableV2ChildHeaderCSS = '_q3b8hi7-2-0-1';
export var dataTableV2FirstBodyRowCSS = '_q3b8hi4-2-0-1';
export var dataTableV2FirstColumnCSS = '_q3b8hi0-2-0-1';
export var dataTableV2FirstHeaderRowCSS = '_q3b8hi2-2-0-1';
export var dataTableV2FirstRightPinnedColumnCSS = '_q3b8hid-2-0-1';
export var dataTableV2FirstUnpinnedColumnCSS = '_q3b8hib-2-0-1';
export var dataTableV2LastBodyRowCSS = '_q3b8hi5-2-0-1';
export var dataTableV2LastColumnCSS = '_q3b8hi1-2-0-1';
export var dataTableV2LastHeaderRowCSS = '_q3b8hi3-2-0-1';
export var dataTableV2LastLeftPinnedColumnCSS = '_q3b8hic-2-0-1';
export var dataTableV2ParentHeaderCSS = '_q3b8hi6-2-0-1';
export var dataTableV2PinnedCellInDragOverlayCSS = '_q3b8hi9-2-0-1';
export var dataTableV2PinnedColumnCSS = '_q3b8hie-2-0-1';
export var dataTableV2PrefixColumnCSS = '_q3b8hi8-2-0-1';
export var dataTableV2RowActionsColumnCSS = '_q3b8hia-2-0-1';